import React from "react";
import { Table, Skeleton } from "antd";
import Column from "antd/es/table/Column";
import NoDataIcon from "../../../../assets/svg/no-data.svg";
import { useTranslation } from "react-i18next";

const AssemblyDataTable = ({
  isDataAvailable,
  data,
  villageFetchedData,
  selectedMarker,
  villageLoading,
  constituencyLoading
}) => {
  const { t } = useTranslation();
  return (
    <div className='constituenct-data-table'>
      <h1>
        {selectedMarker?.title || t("Assembly")} {t("Form 20 Data")}
      </h1>

      {isDataAvailable ? (
        <Table
          rowKey={(record) => record.type}
          dataSource={data}
          locale={{
            emptyText:
              villageLoading || !data ? (
                <div
                  style={{
                    marginLeft: "20px",
                    marginTop: "20px",
                    width: "95%"
                  }}
                >
                  {" "}
                  {/* Container with 90% width */}
                  <Skeleton
                    title={false}
                    active
                    paragraph={{
                      rows: 5,
                      width: ["100%", "100%", "100%", "100%", "100%"],
                      height: ["30px", "30px", "30px", "30px", "30px"]
                    }}
                  />
                </div>
              ) : (
                <div className='no-data-icon mt-20'>
                  <img src={NoDataIcon} alt='' />
                  <h1>{t("No Data Available")}</h1>
                </div>
              )
          }}
        >
          <Column
            title='Party'
            dataIndex='partyName'
            render={(text, record) => (
              <span
                style={{
                  fontWeight: "bold",
                  color: record.partyColorCode,
                  textTransform: "capitalize"
                }}
              >
                {text}
              </span>
            )}
          />
          <Column
            title='Vote Share'
            dataIndex='voteShare'
            render={(text) => (
              <div style={{ textAlign: "center" }}>
                {text !== null && text !== undefined ? text : "-"}
              </div>
            )}
          />

          <Column
            title='Vote Share%'
            dataIndex='voteSharePercentage'
            render={(text) => (
              <div style={{ textAlign: "center" }}>
                {text !== null && text !== undefined
                  ? `${parseFloat(text).toFixed(2)}%`
                  : "-"}
              </div>
            )}
          />

          <Column
            title='Polling Station'
            dataIndex='noOfPSWon'
            render={(text) => (
              <div style={{ textAlign: "center" }}>
                {text !== null && text !== undefined ? text : "-"}
              </div>
            )}
          />
        </Table>
      ) : (
        !constituencyLoading ? 
        (<div className='no-data-icon'>
          <img src={NoDataIcon} alt=''></img>
          <h1>{t("No Data Available")}</h1>
        </div>) : 
        (<div
            style={{
              marginLeft: "20px",
              marginTop: "20px",
              width: "95%"
            }}
          >
            {" "}
            <Skeleton
              title={false}
              active
              paragraph={{
                rows: 5,
                width: ["100%", "100%", "100%", "100%", "100%"],
                height: ["30px", "30px", "30px", "30px", "30px"]
              }}
            />
          </div>)
      )}
    </div>
  );
};

export default AssemblyDataTable;
